<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <line class="a" x1="23.25" y1="0.748" x2="14.25" y2="9.748" />

        <polyline class="a" points="9.75 20.998 9.75 14.248 3 14.248" />

        <polyline class="a" points="14.25 2.998 14.25 9.748 21 9.748" />

        <line class="a" x1="9.75" y1="14.248" x2="0.75" y2="23.248" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'ShrinkIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
